import { request } from "@/api/auth";

export type MarketProcEnterprise = {
  id: string;
  enterpriseName?: string;
  unifiedSocialCreditCode?: string;
  customerId?: string;
};

export type MarketProcAccess = {
  enabled: boolean;
  message?: string;
  enterprises: MarketProcEnterprise[];
};

export type MarketProcWorkOrder = {
  id: string;
  workOrderNo?: string;
  customerName?: string;
  fileName?: string;
  fileUrl?: string;
  status?: string;
  destinationCountry?: string;
  productQuantity?: number;
  boxCount?: number;
  totalAmount?: number | string;
  currency?: string;
  createTime?: string;
};

export type MarketProcWorkOrderQuery = {
  current?: number;
  size?: number;
  customerId?: string;
  workOrderNo?: string;
  status?: string;
  createStartTime?: string;
  createEndTime?: string;
};

export type MarketProcWorkOrderPage = {
  records?: MarketProcWorkOrder[];
  current?: number;
  size?: number;
  total?: number;
  pages?: number;
};

export function getMarketProcAccess() {
  return request<MarketProcAccess>("/api/c/foreign-trade/marketProc/work-order/access");
}

export function bindMarketProcEnterprise(enterpriseName: string, unifiedSocialCreditCode: string) {
  return request<void>("/api/c/foreign-trade/marketProc/work-order/bind-enterprise", {
    enterpriseName,
    unifiedSocialCreditCode,
  });
}

export function createMarketProcWorkOrder(customerId: string, fileUrl: string, fileName: string) {
  return request<void>("/api/c/foreign-trade/marketProc/work-order/add", {
    customerId,
    fileUrl,
    fileName,
    bizType: "1039",
  });
}

export function getMarketProcWorkOrders(query: MarketProcWorkOrderQuery = {}) {
  const params = new URLSearchParams();
  Object.entries({ current: 1, size: 10, ...query }).forEach(([key, value]) => {
    if (value !== undefined && value !== "") params.set(key, String(value));
  });
  return request<MarketProcWorkOrderPage>(`/api/c/foreign-trade/marketProc/work-order/page?${params}`);
}
